import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  statusLabelAuthorized: {
    color: theme.palette.statusLabel.success.primary,
    backgroundColor: theme.palette.statusLabel.success.secondary,
    fontWeight: 600,
  },
  statusLabelRevoked: {
    color: theme.palette.statusLabel.error.primary,
    backgroundColor: theme.palette.statusLabel.error.secondary,
    fontWeight: 600,
  },
  userIconBox: {
    height: 40,
    width: 40,
    borderRadius: '50%',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.white,
  },
  buttonLink: {
    textTransform: 'none',
    paddingInline: theme.spacing(2),
  },
  userPaperContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingInline: theme.spacing(4),
    paddingBlock: theme.spacing(2),
    backgroundColor: theme.palette.lightGray,
    borderBottom: 'none',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  contentPaperContainer: {
    paddingInline: theme.spacing(4),
    paddingBlock: theme.spacing(2),
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(2),
  },
  scrollbar: {
    display: 'flex',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}))

export default useStyles
